/**
 * Used to set image urls to http or https as appropriate for the environment
 */
angular.module('qkr').directive('sslCheckSrc', (utils) => {
    const sslCheckSrc = {
        link: function postLink(scope, iElement, iAttrs) {
            const cur = angular.element(this).attr('src');
            if (cur !== iAttrs.sslCheckSrc) {
                angular.element(iElement).attr('src', utils.checkSSL(iAttrs.sslCheckSrc));
            }
        }
    };
    return sslCheckSrc;
});




// WEBPACK FOOTER //
// ./src/directives/ssl_check_image.js